import { useCallback, useEffect, useRef } from 'react';
import { useBreakPointDown } from '@/hooks/breakPoint';
import { classnames } from '@/utils/classnames';

interface IStickyHeaderProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export const StickyHeader: React.FC<
  React.PropsWithChildren<IStickyHeaderProps>
> = ({ className, children }) => {
  const stickyHeaderRef = useRef<HTMLDivElement>(null);
  const emptySpaceRef = useRef<HTMLDivElement>(null);

  const isMdDown = useBreakPointDown('md');

  const setEmptySpaceHeight = useCallback(() => {
    if (stickyHeaderRef?.current && emptySpaceRef?.current && isMdDown) {
      const stickyFooterHeight = stickyHeaderRef.current.clientHeight;
      emptySpaceRef.current.style.height = `${stickyFooterHeight - 16}px`;
    }
  }, [isMdDown]);

  useEffect(() => {
    setEmptySpaceHeight();
  }, [setEmptySpaceHeight]);

  useEffect(() => {
    window.addEventListener('scroll', setBoxShadow);
    return () => {
      window.removeEventListener('scroll', setBoxShadow);
    };
  });

  const setBoxShadow = () => {
    if (stickyHeaderRef.current) {
      const scrollTop = window.scrollY;
      scrollTop >= 10
        ? (stickyHeaderRef.current.style.boxShadow =
            '0px -4px 20px rgba(0, 0, 0, 0.15)')
        : (stickyHeaderRef.current.style.boxShadow = 'none');
    }
  };

  return (
    <>
      {isMdDown ? (
        <>
          <div ref={emptySpaceRef} className="md:hidden" />
          <div
            ref={stickyHeaderRef}
            className={classnames(
              'fixed left-0 top-0 z-50 w-full bg-white pt-4',
              'md:static md:pb-0',
              className
            )}
          >
            {children}
          </div>
        </>
      ) : (
        children
      )}
    </>
  );
};
